module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content article"
  }, [_c('div', {
    staticClass: "article-body"
  }, [_c('h1', {
    staticClass: "article-title"
  }, [_vm._v("The Data")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('p', [_vm._v("There are four data sets shown on this site.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('blockquote', [_vm._v("\n          \"Displays the locations and attributes of collisions that occur within Seattle. All collisions are provided by the Seattle Police Department and Washington State Department of Transportation and are recorded by Traffic Records for the last 10 years. This includes all types of collisions. Collisions are shown at the intersection or mid-block of a street segment that is closest to where it occurred.\"\n        ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("\n          Building this site required combining the knowledge stored in these two different places. The knowledge stored in the PDF and the knowledge of how to use Socrata's API. The PDF from SDOT tells us what the data means and Socrata's developer portal tells us how to access the data and what format it is stored in. \n        ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("\n          The data from the Seattle Department of Transportation (SDOT) has the following five levels of severity. \n        ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_vm._v("\n          We mapped the NSC severities to the SDOT severities as follows.  \n        ")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('blockquote', [_vm._v("\n          \"The figures above are appropriate for measuring the economic loss to a community resulting from past motor-vehicle crashes. They should not be used, however, in computing the dollar value of future benefits due to traffic safety measures because they do not include the value of a person's natural desire to live longer or to protect the quality of one's life. That is, the economic loss estimates do not include what people are willing to pay for improved safety.\"\n        ")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/cathytuttle"
    }
  }, [_vm._v("Cathy Tuttle")]), _vm._v(" recommended we use the more conservative economic costs number. Below is a table for the economic costs used for the calculations in this application. The headings are the NSC label / SDOT label. It would be nice to have the ability to switch between economic & comprehensive costs. I have this on my "), _c('router-link', {
    attrs: {
      "to": {
        name: 'toDo'
      }
    }
  }, [_vm._v("to do list")]), _vm._v(". \n        ")], 1), _vm._v(" "), _c('table', {
    staticClass: "teal small"
  }, [_vm._m(11), _vm._v(" "), _c('tbody', _vm._l((_vm.costs), function(cost, year) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(year))]), _vm._v(" "), _vm._l((cost), function(dollars) {
      return _c('td', [_vm._v("$" + _vm._s(Number(dollars.amount).toLocaleString('en-US')))])
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(cost[0].desc))])], 2)
  }), 0)]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('p', [_vm._v("\n          With some refactoring from my code to create the neighborhood boundaries, I imported the City Council District boundaries, created similar API endpoints, and similar views. I'd like to make these district views better. Perhaps show a list of neighborhoods within each district!\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#sdot"
    }
  }, [_vm._v("Seattle Department of Transportation (SDOT) Collisions")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#costs"
    }
  }, [_vm._v("Economic costs of collision severity")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#neighborhoods"
    }
  }, [_vm._v("Seattle neighborhood geospatial boundaries")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#districts"
    }
  }, [_vm._v("Seattle City Council District geospatial boundaries")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "sdot"
    }
  }), _vm._v("Seattle Department of Transportation (SDOT) Collisions")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          According to description on the "), _c('a', {
    attrs: {
      "href": "//data.seattle.gov/Transportation/SDOT-Collisions/v7k9-7dn4/about"
    }
  }, [_vm._v("SDOT Collisions about page")]), _vm._v(" as of Sunday May 21, 2017 10:52pm PST, this data is described as...\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          There is a "), _c('a', {
    attrs: {
      "href": "//data.seattle.gov/api/assets/486A95FC-CA9B-4360-97E0-58FB5C35DA5F?download=true"
    }
  }, [_vm._v("PDF that describes the data fields available")]), _vm._v(". There is also a "), _c('a', {
    attrs: {
      "href": "//dev.socrata.com/foundry/data.seattle.gov/v7k9-7dn4"
    }
  }, [_vm._v("json feed to the data provided by Socrata")]), _vm._v(". Socrata is the company hired by the city to host their open data. They provide the platform & software. However, it is up to the city to use Socrata, enter the data, make sure the data is accurate, and answer questions about the data. \n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "costs"
    }
  }), _vm._v("Economic costs of collision severity")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Every year the "), _c('a', {
    attrs: {
      "href": "//www.nsc.org"
    }
  }, [_vm._v("National Safety Council (NSC)")]), _vm._v(" publishes their "), _c('a', {
    attrs: {
      "href": "http://www.nsc.org/learn/safety-knowledge/Pages/injury-facts.aspx"
    }
  }, [_vm._v("Injury Facts®")]), _vm._v(" report. This report includes an estimated \"Cost of Motor-Vehicle Injuries\". Here is a "), _c('a', {
    attrs: {
      "href": "//www.nsc.org/NSCDocuments_Corporate/estimating-costs.pdf"
    }
  }, [_vm._v("sample of a Cost of Motor-Vehicle Injuries report")]), _vm._v(". The National Safety Council categorizes collisions with the following six levels of severity. \n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Death")]), _vm._v(" "), _c('li', [_vm._v("Disabling")]), _vm._v(" "), _c('li', [_vm._v("Evident")]), _vm._v(" "), _c('li', [_vm._v("Possible")]), _vm._v(" "), _c('li', [_vm._v("No injury observed")]), _vm._v(" "), _c('li', [_vm._v("Property damage only")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Fatality collision (sdot code 3)")]), _vm._v(" "), _c('li', [_vm._v("Serious injury collision (sdot code 2b)")]), _vm._v(" "), _c('li', [_vm._v("Injury (sdot code 2)")]), _vm._v(" "), _c('li', [_vm._v("Unknown (sdot code 0)")]), _vm._v(" "), _c('li', [_vm._v("Property damage only collision (sdot code 1)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Death (nsc) -> Fatality collision (sdot code 3)")]), _vm._v(" "), _c('li', [_vm._v("Disabling (nsc) -> Serious injury collision (sdot code 2b)")]), _vm._v(" "), _c('li', [_vm._v("Evident (nsc) -> Injury (sdot code 2)")]), _vm._v(" "), _c('li', [_vm._v("Possible (nsc) -> Unknown (sdot code 0)")]), _vm._v(" "), _c('li', [_vm._v("Property damage only (nsc) -> Property damage only collision (sdot code 1)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The National Safety Council also has TWO sets of estimated costs, \"economic\" and \"comprehensive\" costs. In the "), _c('a', {
    attrs: {
      "href": "//www.nsc.org/NSCDocuments_Corporate/estimating-costs.pdf"
    }
  }, [_vm._v("sample report")]), _vm._v(" the National Safety Council says the following about the meaning of \"Economic Costs\".\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          So, the \"economic cost\" is basically the cost of the "), _c('em', [_vm._v("past damage")]), _vm._v(" done by collisions where comprehensive costs includes a person's desires for the future. Notice in the "), _c('a', {
    attrs: {
      "href": "//www.nsc.org/NSCDocuments_Corporate/estimating-costs.pdf"
    }
  }, [_vm._v("sample report")]), _vm._v(", the economic costs are lower than the comprehensive cost since economic costs do not include benefits gained from safety improvement investments and changes in quality of life of those involved in a collision.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Year")]), _vm._v(" "), _c('th', [_vm._v("Death / Fatality")]), _vm._v(" "), _c('th', [_vm._v("Disabling / Serious injury")]), _vm._v(" "), _c('th', [_vm._v("Evident injury / Injury")]), _vm._v(" "), _c('th', [_vm._v("Possible injury / Severity unknown")]), _vm._v(" "), _c('th', [_vm._v("Property damage only / property damage")]), _vm._v(" "), _c('th', [_vm._v("Notes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "neighborhoods"
    }
  }), _vm._v("Seattle neighborhood geospatial boundaries")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The "), _c('a', {
    attrs: {
      "href": "//data.seattle.gov/Transportation/SDOT-Collisions/v7k9-7dn4/about"
    }
  }, [_vm._v("data provided by the Seattle Department of Transportation")]), _vm._v(" includes latitude & longitude coordinates for a collision. However, we don't know what neighborhood these coodinates fall in. I wanted to be able to view collisions by neighborhood so I had to find neighborhoood geospatial boundaries. Turns out that "), _c('a', {
    attrs: {
      "href": "https://www.zillow.com/howto/api/neighborhood-boundaries.htm"
    }
  }, [_vm._v("Zillow has neighborhood boundaries in shapefiles")]), _vm._v(". However, this does me little good since I need the coordinates in a format that I can store in my database. \n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          After some searching on GitHub I found a "), _c('a', {
    attrs: {
      "href": "//github.com/mashvisor/us-neighborhoods-boundaries"
    }
  }, [_vm._v("repository by Mashvisor that has the Zillow shape files converted into GeoJSON and CSV")]), _vm._v(". The "), _c('a', {
    attrs: {
      "href": "//github.com/mashvisor/us-neighborhoods-boundaries/blob/master/out/csv/WA-Regions.csv"
    }
  }, [_vm._v(".csv file for Washington State")]), _vm._v(" is the one I used to create the multipolygon datatypes in my database. \n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "districts"
    }
  }), _vm._v("Seattle City Council geospatial boundaries")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/cathytuttle"
    }
  }, [_vm._v("Cathy")]), _vm._v(" & "), _c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/gordonpadelford"
    }
  }, [_vm._v("Gordon")]), _vm._v(" mentioned that it would be interesting to see collisions by district. I attened an "), _c('a', {
    attrs: {
      "href": "http://openseattle.org/"
    }
  }, [_vm._v("Open Seattle")]), _vm._v(" meetup and "), _c('a', {
    attrs: {
      "href": "https://github.com/JacksonMaxfield"
    }
  }, [_vm._v("Jackson Maxfield")]), _vm._v(" introduced me to "), _c('a', {
    attrs: {
      "href": "http://seattle.io"
    }
  }, [_vm._v("Seattle.io")]), _vm._v(". I don't know why I didn't come across this before! Turns out there are "), _c('a', {
    attrs: {
      "href": "https://github.com/seattleio/seattle-boundaries-data/tree/master/data"
    }
  }, [_vm._v("a bunch of boundaries available")]), _vm._v(" here including "), _c('a', {
    attrs: {
      "href": "https://github.com/seattleio/seattle-boundaries-data/blob/master/data/city-council-districts.geojson"
    }
  }, [_vm._v("City Council Districts")]), _vm._v(". Yay!\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-138175d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/about/Data.vue
// module id = 420
// module chunks = 1